import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux"
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import store from "./store"

import axios from 'axios'
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {toast} from "react-toastify";

import history from "./history";

import * as auth from "./utils/auth"

import { ConnectedRouter } from 'connected-react-router'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE;

axios.interceptors.request.use(
  config => {
    if (config.baseURL === process.env.REACT_APP_API_BASE && !config.headers.Authorization) {
      const token = localStorage.getItem('token');

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Handle errors
    if (error.response.status === 401) {
      toast.error("You're not authorized.")
      auth.clear_token()
    }else if (error.response.status === 403) {
      toast.error("You lack the permissions to see this.")
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js